<template>
  <div class="d-flex justify-center">
    <div class="_60_w mt-3">
      <v-card class="d-flex justify-space-between rounded-lg pa-3 mb-3" flat>
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon small @click="$router.go(-1)"
              ><v-icon>mdi-undo</v-icon></v-btn
            >
          </template>
          <span>Back</span>
        </v-tooltip>
        <h3>Progress Blast Email</h3>
        <div></div>
      </v-card>
      <v-card
        class="pa-3 mb-3 rounded-lg"
        v-for="(item, i) in dataSet"
        :key="i"
        flat
      >
        <p class="default_txt">
          Progress At {{ $date(item.createdAt).format("DD, MMMM, YYYY") }},
          {{ $date(item.createdAt).format("HH:mm") }}
        </p>

        <v-divider></v-divider>
        <p class="default_txt">
          Status : {{ item.progress == 100 ? "Done" : "Progress" }}
        </p>
        <p class="default_txt">Total : {{ item.totalJobs }}</p>
        <p class="default_txt">Sent : {{ item.processedJobs }}</p>
        <p class="default_txt">Failed : {{ item.failedJobs }}</p>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "progressBlast",
  data() {
    return {
      loading: false,
      dataSet: null,
      page: 1,
      limit: 10,
      total: null,
      last_page: null,
    };
  },
  mounted() {
    this.fetchData();
  },

  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/contract/batch/sender`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
  },
};
</script>

<style socped>
.bold_ {
  font-size: 20px;
  font-weight: bold;
}
</style>